<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Visa Details ({{visaId}})</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          
          <ion-button class="filled-blue-btn" (click)="editVisa()">
            Edit
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" >
      <div  id="print-visa-section" class="px-3">
        <div>
          <div class="section-container" *ngIf="leadDetails">
            <div class="title-container">
              <h2 class="title">Lead Information</h2>
            </div>
            <div class="content-container">
              <div class="row">
                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Lead ID</p>
                    <p class="value">{{leadDetails.leadId}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Name</p>
                    <p class="value">{{leadDetails.firstName}} {{leadDetails.lastName}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Phone Number</p>
                    <p class="value">{{leadDetails.phoneNumber.countryCode}} {{leadDetails.phoneNumber.phone}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Email</p>
                    <p class="value">{{leadDetails.email || '--'}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Source</p>
                    <p class="value">{{leadDetails.source}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Status</p>
                    <p class="value">{{leadDetails.status}}</p>
                  </div>
                </div>

                <div class="col-4">
                  <div class="item-container">
                    <p class="label">Priority</p>
                    <p class="value">{{leadDetails.priority}}</p>
                  </div>
                </div>

                <div class="col-4">
                  <div class="item-container">
                    <p class="label">Owner</p>
                    <p class="value">{{leadDetails.ownershipName}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Trip details section -->
          <div class="section-container" *ngIf="visaLeadDetails">
            <div class="title-container">
              <h2 class="title">Trip Information</h2>
            </div>
            <div class="content-container">
              <div class="row">
                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Destination</p>
                    <p class="value">{{visaLeadDetails.destination}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Nights</p>
                    <p class="value">{{visaLeadDetails.nights}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">Start Date</p>
                    <p class="value">{{visaLeadDetails.startDate | date}}</p>
                  </div>
                </div>

                <div class="col-3">
                  <div class="item-container">
                    <p class="label">End Date</p>
                    <p class="value">{{visaLeadDetails.endDate | date}}</p>
                  </div>
                </div>

                <div class="col-4">
                  <div class="item-container">
                    <p class="label">No. Of Passengers</p>
                    <p class="value">{{visaLeadDetails.totalAdults}} Adults | {{visaLeadDetails.totalChildrens}} Children</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- status section -->
          <div class="section-container" *ngIf="visaDocumentsDetails">
            <div class="title-container">
              <h2 class="title">Visa Status</h2>
            </div>
            <div class="content-container">
              <div class="passenger-container" *ngFor="let passenger of visaDocumentsDetails.data">
                <div>
                  <div class="row passenger-row">
                    <div class="col-3">
                      <div class="passenger-input">
                        <label class="label">Passenger Name</label>
                        <div>
                          <p class="value">{{passenger.firstName}}</p>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-1">
                      <div class="passenger-input">
                        <label class="label">Age</label>
                        <div>
                          <p class="value">{{calculateAge(passenger.dateOfBirth)}}</p>
                        </div>
                      </div>
                    </div> -->
                    <div class="col-2">
                      <div class="passenger-input">
                        <label class="label">Gender</label>
                        <div>
                          <p class="value">{{passenger.gender}}</p>
                        </div>
                      </div>
                    </div>
                    <div  class="col-2">
                      <div class="passenger-input">
                        <label class="label">Nationality</label>
                        <div>
                          <p class="value">{{passenger.nationality}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="passenger-input">
                        <label class="label">Applicant Type</label>
                        <div>
                          <p class="value">{{passenger.applicantType}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="passenger-input">
                        <label class="label">Visa Type</label>
                        <div>
                          <p class="value">{{passenger.visaType}}</p>
                        </div>
                      </div>
                    </div>
                    
                  </div>
    
                  <div class="row my-1">
                    <div class="col-12">
                      <app-status-progress-bar-input [isDisabled]="true" [(ngModel)]="passenger.status"></app-status-progress-bar-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Visa checklist container -->
           <div class="section-container" *ngIf="visaImportantInformation">
            <div class="title-container">
              <h2 class="title">Visa Checklist</h2>
            </div>

            <div class="content-container">
              <ng-container *ngFor="let item of visaChecklistArray">
                <div class="d-flex justify-content-start mb-2" *ngIf="item.isDocumentRequired">
                  <div>
                    <i class="point-style-arrow"></i><div class=""></div>
                  </div>
                  <div class="checklist-container">
                    <p class="value"><span class="bold">{{item.name}}</span></p>
                    <p class="value"><span class="bold">Note : </span>{{item.note}}</p>
                  </div>
                </div>
              </ng-container>
              <div class="p-2 text-center" *ngIf="!visaChecklistArray?.length">
                <p class="mb-0">No Items Added!</p>
              </div>
            </div>
           </div>

           <!-- Notes container -->
           <div class="section-container" *ngIf="visaImportantInformation">
            <div class="title-container">
              <h2 class="title">Notes</h2>
            </div>

            <div class="content-container">
              <ng-container *ngFor="let item of visaNotesArray">
                <div class="d-flex justify-content-start mb-2" *ngIf="item.isDocumentRequired">
                  <div>
                    <i class="point-style-arrow"></i><div class=""></div>
                  </div>
                  <div class="checklist-container">
                    <p class="value"><span class="bold">{{item.name}}</span></p>
                    <p class="value"><span class="bold">Note : </span>{{item.note}}</p>
                  </div>
                </div>
              </ng-container>
              <div class="p-2 text-center" *ngIf="!visaNotesArray?.length">
                <p class="mb-0">No Notes Added!</p>
              </div>
            </div>
           </div>


        </div>
      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->
  